import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  ModelSignal,
  OutputEmitterRef,
  input,
  model,
  output,
} from '@angular/core';

import { IndustryCatalogType } from '@core/shared/domain';
import { CatalogTypeIconComponent } from '@core/ui';
import { PlatformSupplierBasic } from '@mp/supplier-management/common/domain';

import { SupplierAutocompleteInputComponent } from '../supplier-autocomplete-input/supplier-autocomplete-input.component';

@Component({
  selector: 'mpsm-catalog-supplier-selector',
  templateUrl: './catalog-supplier-selector.component.html',
  styleUrl: './catalog-supplier-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SupplierAutocompleteInputComponent, CatalogTypeIconComponent],
})
export class CatalogSupplierSelectorComponent {
  readonly supplier: ModelSignal<PlatformSupplierBasic | undefined> = model<PlatformSupplierBasic | undefined>(
    undefined,
  );
  readonly platformSuppliers: InputSignal<PlatformSupplierBasic[]> = input<PlatformSupplierBasic[]>([]);
  readonly isLoadingPlatformSuppliers: InputSignal<boolean> = input<boolean>(false);
  readonly editMode: InputSignal<boolean> = input<boolean>(false);
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  readonly catalogType: InputSignal<IndustryCatalogType | undefined> = input<IndustryCatalogType | undefined>(
    undefined,
  );
  readonly label: InputSignal<string> = input<string>('Plattformlieferanten zuordnen');
  readonly placeholder: InputSignal<string> = input<string>('Plattformlieferanten zuordnen');
  readonly icon: InputSignal<string> = input<string>('local_shipping');

  readonly searchTermChange: OutputEmitterRef<string> = output<string>();

  onSupplierChanges(supplier?: PlatformSupplierBasic): void {
    this.supplier.set(supplier);
  }
}
